export function getQASelector(
  component: React.FC<any> | undefined = undefined,
  id: string = "",
  suffix: string = "",
): string {
  const componentName =
    component?.displayName || component?.name || "qa-selector";
  const prefix = componentName
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .toLowerCase();
  const identifier = id ? "-" + id.replace(/[^a-zA-Z0-9]/g, "") : "";
  const cleanSuffix = suffix ? "-" + suffix.replace(/[^a-zA-Z0-9]/g, "") : "";

  return `${prefix}${identifier}${cleanSuffix}`;
}
